import PasswordField from '@cnamts/vue-dot/src/patterns/PasswordField'

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(PasswordField,_vm._b({staticClass:"vd-form-input",attrs:{"value":_vm.field.value},on:{"change":_vm.emitChangeEvent}},'PasswordField',_vm.field.fieldOptions,false))
}
var staticRenderFns = []

export { render, staticRenderFns }